import axiosInstance from 'api/axiosInstance';

/**
 * Retrieves a list of prospect history events for a given prospect ID.
 * @param {number | null} prospectId - The ID of the prospect.
 * @returns {Promise<any[]>} - A promise that resolves to an array of prospect history events.
 * @throws Will throw an error if the prospectId is null or the API request fails.
 */
const getProspectHistoryEvents = async (
	prospectId: number | null,
): Promise<any[]> => {
	if (prospectId === null || prospectId === undefined) {
		console.error('Error: prospectId is null or undefined.');
		throw new Error('Invalid prospect ID. Cannot retrieve history events.');
	}

	try {
		const { data } = await axiosInstance.get(
			`/api/cantrackv3/ProspectHistoryEvents`,
			{
				params: { id: prospectId },
			},
		);

		console.log('DEBUG: Retrieved prospect history events:', data);
		return data;
	} catch (error) {
		console.error('Error retrieving prospect history events:', error);
		throw error;
	}
};

export default getProspectHistoryEvents;
